export enum FeatureFlag {
  SWITCH_CLASS_LAYER = 'switch_class_layer',
  FLASHCARDS = 'flashcards',
}
